import "core-js/modules/es6.number.constructor";
import { toast } from '@ykz/ykz-util/base';
import databus, { Origins } from '@ykz/ykz-http/core';
export default {
  name: 'redPacketPopup',
  props: {
    pageType: {
      type: Number,
      default: 3
    }
  },
  data: function data() {
    return {
      weChatId: getUrlParams('weChatId') || 1,
      noticeChecked: false,
      showRedpacketPopup: false,
      activityInfo: {},
      showRedPacket: false
    };
  },
  mounted: function mounted() {
    window.componentCenter.redPacketPopup = this;
  },
  methods: {
    initComponent: function initComponent() {
      this.getPopRedPacket();
    },
    launch: function launch() {
      var that = this;
      return new Promise(function (resolve, reject) {
        databus({
          url: '/api/assistActivity/launchActivity',
          data: {
            launchId: 0,
            activityId: that.activityInfo.activityId,
            pageType: that.pageType
          },
          origin: Origins.API_MARKETING,
          success: function success(res) {
            if (res.code === 1000 && res.bcode === 100) {
              resolve(res.content);
            } else if (res.code === 1001 && res.bcode === 101) {
              toast(res.message);
              reject();
            } else {
              reject();
            }
          },
          error: function error() {
            reject();
          },
          complete: function complete() {}
        });
      });
    },
    //获取城市列表
    getCityList: function getCityList() {
      return new Promise(function (resolve, reject) {
        try {
          // 从缓存读取是否有 provinceList, 没有则从接口里调用
          var provinceList = [];
          var provinceListCache = window.localStorage.getItem('provinceList');
          if (provinceListCache) {
            provinceList = JSON.parse(provinceListCache);
            resolve(provinceList);
          } else {
            databus({
              url: 'apiv2/marketing/cityProvince',
              data: {},
              success: function success(data) {
                if (data.code == 1000 && data.bcode == 100) {
                  resolve(data.content.dataList || []);
                }
              },
              error: function error() {
                reject();
              }
            });
          }
        } catch (error) {
          console.error('省份数据获取失败');
        }
      });
    },
    // 查找provinceCode 和 cityCode
    getLocationInfo: function getLocationInfo(provinceName, cityName) {
      var locationInfo = {
        provinceCode: 0,
        cityCode: 0
      };
      var that = this;
      return new Promise(function (resolve) {
        that.getCityList().then(function (provinceList) {
          provinceList.map(function (item) {
            if (item.provinceName === provinceName) {
              locationInfo.provinceCode = ~~item.provinceCode;
              item.cityList.map(function (inside) {
                if (inside.cityName === cityName) {
                  locationInfo.cityCode = ~~inside.cityCode;
                  resolve(locationInfo);
                }
              });
            }
          });
        });
      });
    },
    getGPSData: function getGPSData() {
      var gpsData = {
        gpsCity: '',
        gpsProvince: '',
        gpsDistrict: '',
        longitude: 0,
        latitude: 0
      };
      var that = this;
      // 去缓存里读取用户的当前定位信
      var shoppingMallCityInfo = window.localStorage.getItem('shopping_mall_city');
      var globalUserInfo = window.localStorage.getItem('globalUserLocationInfo');
      if (shoppingMallCityInfo) {
        shoppingMallCityInfo = JSON.parse(shoppingMallCityInfo);
        gpsData.gpsProvince = shoppingMallCityInfo.provinceName || '';
        gpsData.gpsCity = shoppingMallCityInfo.cityName || '';
        that.getCityList().then(function (provinceList) {
          provinceList.map(function (item) {
            if (item.provinceName === shoppingMallCityInfo.provinceName) {
              item.cityList.map(function (inside) {
                if (inside.cityName === shoppingMallCityInfo.cityName) {
                  gpsData.longitude = inside.longitude;
                  gpsData.latitude = inside.latitude;
                }
              });
            }
          });
        });
        this.gpsData = gpsData;
      } else if (globalUserInfo) {
        globalUserInfo = JSON.parse(globalUserInfo);
        gpsData = {
          gpsCity: globalUserInfo.city,
          gpsProvince: globalUserInfo.province,
          gpsDistrict: globalUserInfo.district,
          longitude: globalUserInfo.longitude,
          latitude: globalUserInfo.latitude
        };
        this.gpsData = gpsData;
      } else {
        this.gpsData = gpsData;
        return gpsData;
      }
    },
    // 判断当前地区是否有助力活动
    getPopRedPacket: function getPopRedPacket() {
      var that = this;
      var shoppingMallCityInfo = {};
      var globalCityCenterLocationInfo = {};
      var isShoppingMallCity = false;
      return new Promise(function (resolve, reject) {
        try {
          if (window.localStorage.getItem('shopping_mall_city')) {
            isShoppingMallCity = true;
            shoppingMallCityInfo = JSON.parse(window.localStorage.getItem('shopping_mall_city'));
          } else {
            globalCityCenterLocationInfo = JSON.parse(sessionStorage.getItem('globalCityCenterLocationInfo'));
          }
          var province = isShoppingMallCity && shoppingMallCityInfo.provinceName || globalCityCenterLocationInfo.province;
          var city = isShoppingMallCity && shoppingMallCityInfo.cityName || globalCityCenterLocationInfo.city;
          that.getLocationInfo(province, city).then(function (locationInfo) {
            databus({
              url: '/api/assistActivity/hasActivity',
              noLongLatitude: true,
              origin: Origins.API_MARKETING,
              data: $.extend(locationInfo, that.getGPSData()),
              success: function success(res) {
                if (res.code == 1000 && res.bcode == 100) {
                  var activityInfo = res.content ? res.content.activityInfo : null;
                  that.activityInfo = activityInfo;
                  if (activityInfo && res.content.hasPopup === 1) {
                    var today = new Date().toDateString();
                    var cacheInfo = JSON.parse(localStorage.getItem('showBoostRedPacket'));
                    if (cacheInfo && cacheInfo.id === activityInfo.activityId && cacheInfo.date === today) {
                      // 表示今天这个活动弹窗展示过
                      that.$emit('showNextPopup');
                      reject();
                    } else {
                      that.showRedpacketPopup = true;
                      // 每个活动每天只弹一次
                      localStorage.setItem('showBoostRedPacket', JSON.stringify({
                        date: new Date().toDateString(),
                        id: activityInfo.activityId
                      }));
                      that.$emit('hasRedPacketPopup', true);
                      resolve(activityInfo);
                    }
                  } else {
                    that.$emit('showNextPopup');
                  }
                } else {
                  that.$emit('showNextPopup');
                  reject();
                }
              },
              complete: function complete() {
                // var demo = {
                //   "hasPopup": 1,
                //   "activityInfo": {
                //     "activityId": 74,
                //     "activityName": "验证全国活动在各地区展示情况",
                //     "rewardMoney": 88.00,
                //     "endTime": 1612972800,
                //     "hours": 24,
                //     "status": 2
                //   }
                // };
                // that.showRedpacketPopup =
                //   demo.hasPopup === 1 ? true : false;
                // // 当前状态为需要展示弹窗，则缓存状态
                // // window.localStorage.setItem('showRedPacket', false);
                // that.activityInfo = demo.activityInfo;
                // that.$emit('hasRedPacketPopup', that.showRedpacketPopup);
              }
            });
          });
        } catch (error) {
          that.$emit('showNextPopup');
          console.error(error);
        }
      });
    },
    closePopUp: function closePopUp() {
      this.showRedpacketPopup = false;
    },
    // 跳转详情页
    goRedpackageLanding: function goRedpackageLanding() {
      var _this = this;
      this.launch().then(function (res) {
        var detailPapeUrl = "/front/userCenter/boosting?weChatId=".concat(_this.weChatId, "&activityId=").concat(_this.activityInfo.activityId, "&launchId=").concat(res.launchId, "&pageType=").concat(_this.pageType);
        location.href = detailPapeUrl;
      });
    },
    // 是否勾选今日不在提示
    handleNoticeChecked: function handleNoticeChecked() {
      this.noticeChecked = !this.noticeChecked;
      var that = this;
      if (this.noticeChecked) {
        databus({
          url: '/api/assistActivity/readActivity',
          noLongLatitude: true,
          data: {
            activityId: that.activityInfo.activityId
          },
          origin: Origins.API_MARKETING,
          success: function success(res) {
            if (res.code == 1000 && res.bcode == 100) {
              console.log(res);
            }
          },
          complete: function complete() {}
        });
      }
    }
  }
};